(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fn-about-chapters"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const chs = [...root.querySelectorAll('.fn-ac__ch')];
    const slides = root.querySelectorAll('.fn-ac__slide');
    const dots = root.querySelectorAll('.fn-ac__dots li');
    const list = root.querySelector('.fn-ac__list');
    const rail = root.querySelector('.fn-ac__rail i');
    const desk = matchMedia('(min-width: 900px)');
    let cur = -1, raf = 0;
    const set = (i) => {
      if (i === cur) return;
      cur = i;
      chs.forEach((c, k) => c.classList.toggle('is-on', k === i));
      slides.forEach((c, k) => c.classList.toggle('is-on', k === i));
      dots.forEach((c, k) => c.classList.toggle('is-on', k === i));
    };
    const tick = () => {
      raf = 0;
      if (!desk.matches) return;
      const mid = innerHeight * .5;
      let i = 0;
      chs.forEach((c, k) => { if (c.getBoundingClientRect().top < mid) i = k; });
      set(i);
      const r = list.getBoundingClientRect();
      rail.style.setProperty('--p', Math.min(1, Math.max(0, (mid - r.top) / r.height)).toFixed(3));
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(tick); };
    new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) { addEventListener('scroll', onScroll, { passive: true, capture: true }); tick(); }
        else removeEventListener('scroll', onScroll, { capture: true });
      });
    }).observe(root);
    desk.addEventListener('change', tick);
    set(0);
  };
  const run = () => document.querySelectorAll('[data-fn-ac]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:block:select', (e) => {
    const ch = e.target.closest && e.target.closest('.fn-ac__ch');
    if (ch) ch.scrollIntoView({ block: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-about-manifesto"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const words = [];
    root.querySelectorAll('.fn-am__line').forEach((line) => {
      const parts = line.textContent.trim().split(/(\s+)/);
      line.textContent = '';
      parts.forEach((p) => {
        if (/^\s+$/.test(p)) { line.append(' '); return; }
        const w = document.createElement('span');
        w.className = 'fn-am__w';
        w.textContent = p;
        line.append(w);
        words.push(w);
      });
    });
    let raf = 0;
    const paint = () => {
      raf = 0;
      const r = root.querySelector('.fn-am__txt').getBoundingClientRect();
      const vh = innerHeight;
      // 文字块顶部到达屏幕 80% 处开始，底部到达 45% 处全部完成
      const p = Math.min(1, Math.max(0, (vh * .8 - r.top) / (r.height + vh * .35)));
      const n = Math.round(p * words.length);
      words.forEach((w, i) => w.classList.toggle('is-on', i < n));
    };
    const onScroll = () => { if (!raf) raf = requestAnimationFrame(paint); };
    new IntersectionObserver((es) => {
      es.forEach((e) => {
        if (e.isIntersecting) { addEventListener('scroll', onScroll, { passive: true, capture: true }); paint(); }
        else { removeEventListener('scroll', onScroll, { capture: true }); paint(); }
      });
    }).observe(root);
  };
  const run = () => document.querySelectorAll('[data-fn-am]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-about-name"] && !Shopify.designMode) return;
  try {
    
(() => {
  const run = () => document.querySelectorAll('[data-fn-an]:not(.is-in)').forEach((el) => {
    new IntersectionObserver((es, io) => {
      if (es[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: .35 }).observe(el.querySelector('.fn-an__word'));
  });
  run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-about-promise"] && !Shopify.designMode) return;
  try {
    
(() => {
  const run = () => document.querySelectorAll('[data-fn-ap]:not(.is-in)').forEach((el) => {
    new IntersectionObserver((es, io) => {
      if (es[0].isIntersecting) { el.classList.add('is-in'); io.disconnect(); }
    }, { threshold: .3 }).observe(el.querySelector('.fn-ap__cols'));
  });
  run();
  document.addEventListener('shopify:section:load', run);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-before-after"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-ba]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var box = s.querySelector('.fn-ba__box'), r = s.querySelector('.fn-ba__range');
    r.addEventListener('input', function(){ box.style.setProperty('--pos', r.value + '%'); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-craft"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-craft]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var pins = s.querySelectorAll('.fn-craft__pin'), pts = s.querySelectorAll('.fn-craft__pt');
    function on(i){
      pins.forEach(function(p){ p.classList.toggle('is-on', p.dataset.i === i); });
      pts.forEach(function(p){ p.classList.toggle('is-on', p.dataset.i === i); });
    }
    pts.forEach(function(p){
      p.addEventListener('mouseenter', function(){ on(p.dataset.i); });
      p.addEventListener('focus', function(){ on(p.dataset.i); });
      p.addEventListener('click', function(){ on(p.dataset.i); });
    });
    pins.forEach(function(p){ p.addEventListener('click', function(){ on(p.dataset.i); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-faq"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-faq]').forEach(function(s){
    if (s.dataset.fnCats) return; s.dataset.fnCats = '1';
    var chips = s.querySelectorAll('.fn-faq__cats [data-cat]');
    chips.forEach(function(c){
      c.addEventListener('click', function(){
        chips.forEach(function(x){ x.setAttribute('aria-pressed', String(x === c)); });
        s.querySelectorAll('.fn-faq__list details').forEach(function(d){ d.hidden = c.dataset.cat !== 'all' && d.dataset.cat !== c.dataset.cat; if (d.hidden) d.open = false; });
      });
    });
  });
  document.querySelectorAll('[data-fn-faq][data-single="true"]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var items = s.querySelectorAll('details');
    items.forEach(function(d){ d.addEventListener('toggle', function(){ if (d.open) items.forEach(function(x){ if (x !== d) x.open = false; }); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-featured-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-fc]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var tabs = s.querySelectorAll('[role=tab]');
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        tabs.forEach(function(x){ x.setAttribute('aria-selected', String(x === t)); document.getElementById(x.getAttribute('aria-controls')).hidden = x !== t; });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-final-knot"] && !Shopify.designMode) return;
  try {
    
(function(){
  var km=document.querySelector('[data-fh-final] .fh-final__knot'); if(!km||km.dataset.fhReady) return; km.dataset.fhReady='1';
  var kp=km.querySelector('path'); if(!kp.animate||window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var kl=kp.getTotalLength(), done=false;
  kp.style.strokeDasharray=kl; kp.style.strokeDashoffset=kl;
  function tie(){
    if(done) return; done=true;
    kp.animate([{strokeDashoffset:kl},{strokeDashoffset:0}],{duration:1300,easing:'cubic-bezier(.6,0,.3,1)',fill:'forwards'}).onfinish=function(){
      kp.style.strokeDashoffset=0;
      km.animate([{transform:'scale(1)'},{transform:'scale(.86)'},{transform:'scale(1.04)'},{transform:'scale(1)'}],{duration:520,easing:'ease-out'});
    };
  }
  document.addEventListener('fh:thread-end',tie);
  /* 没有「贯穿全页的线」模块时：滚到结尾就打结 */
  if(!document.querySelector('[data-fh-thread]') && 'IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){ if(es[0].isIntersecting){ io.disconnect(); tie(); } },{threshold:.6}); io.observe(km);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-footer"] && !Shopify.designMode) return;
  try {
    
(function(){
  // 移动端默认收起页脚链接列，桌面端始终展开
  if (window.matchMedia('(max-width: 899px)').matches) {
    document.querySelectorAll('.fn-ft__col[open]').forEach(function(d){ d.removeAttribute('open'); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-gift-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-gift]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var tabs = s.querySelectorAll('[data-tab]');
    tabs.forEach(function(t){
      t.addEventListener('click', function(){
        tabs.forEach(function(x){ x.setAttribute('aria-selected', String(x === t)); });
        s.querySelectorAll('[data-for]').forEach(function(c){ c.hidden = c.dataset.for !== t.dataset.tab; });
        var g = s.querySelector('.fn-gift__grid'); if (g) g.scrollLeft = 0;
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-gift-shop"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fh-shop]').forEach(function(s){
    if (s.dataset.fhReady) return; s.dataset.fhReady='1';
    var chips=[].slice.call(s.querySelectorAll('.fh-chip')), panels=[].slice.call(s.querySelectorAll('.fh-grid4')), note=s.querySelector('[data-fh-note]');
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    chips.forEach(function(c){
      c.addEventListener('click',function(){
        chips.forEach(function(x){ x.setAttribute('aria-selected',x===c?'true':'false'); });
        panels.forEach(function(p){ p.hidden=p.dataset.i!==c.dataset.i; });
        note.textContent=c.dataset.note||'';
        if(reduce||!c.animate) return;
        c.animate([{transform:'scale(1)'},{transform:'scale(1.08)'},{transform:'scale(1)'}],{duration:260,easing:'ease-out'});
        if(note.textContent) note.animate([{opacity:0,transform:'translateY(4px)'},{opacity:1,transform:'none'}],{duration:360,easing:'ease-out'});
        var shown=panels.filter(function(p){return !p.hidden})[0];
        if(shown) [].forEach.call(shown.children,function(card,i){
          card.animate([{opacity:0,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:480,delay:i*70,easing:'cubic-bezier(.3,.7,.4,1)',fill:'backwards'});
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-header]').forEach(function(hdr){
    if (hdr.dataset.fnReady) return; hdr.dataset.fnReady = '1';
    var items = hdr.querySelectorAll('[data-fn-mega-item]');
    var canHover = window.matchMedia('(hover:hover)').matches;
    var timer;
    function closeAll(except){
      items.forEach(function(it){
        var b = it.querySelector('.fn-hdr__link[aria-controls]'), p = it.querySelector('.fn-mega');
        if (!b || it === except) return;
        b.setAttribute('aria-expanded','false'); p.hidden = true;
      });
    }
    function open(it){
      var b = it.querySelector('.fn-hdr__link[aria-controls]'), p = it.querySelector('.fn-mega');
      if (!b) { closeAll(); return; }
      closeAll(it); b.setAttribute('aria-expanded','true'); p.hidden = false;
    }
    items.forEach(function(it){
      var b = it.querySelector('.fn-hdr__link[aria-controls]');
      if (canHover) {
        it.addEventListener('mouseenter', function(){ clearTimeout(timer); timer = setTimeout(function(){ open(it); }, 80); });
      }
      if (b) b.addEventListener('click', function(e){
        var expanded = b.getAttribute('aria-expanded') === 'true';
        if (b.tagName === 'A') {
          // 能悬停的设备直接跳转；触屏第一下展开面板，第二下才跳转
          if (canHover || expanded) return;
          e.preventDefault(); open(it); return;
        }
        expanded ? closeAll() : open(it);
      });
      // 键盘：链接上按 ↓ 展开面板，Tab 进入面板
      if (b && b.tagName === 'A') b.addEventListener('keydown', function(e){ if (e.key === 'ArrowDown') { e.preventDefault(); open(it); } });
    });
    hdr.addEventListener('mouseleave', function(){ clearTimeout(timer); if (canHover) timer = setTimeout(closeAll, 180); });
    hdr.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeAll(); closeDrawer(); } });
    document.addEventListener('click', function(e){ if (!hdr.contains(e.target)) closeAll(); });

    // 搜索
    var search = hdr.querySelector('.fn-search');
    hdr.querySelectorAll('[data-fn-search-toggle]').forEach(function(t){
      t.addEventListener('click', function(){
        search.hidden = !search.hidden; closeAll();
        hdr.querySelectorAll('[data-fn-search-toggle]').forEach(function(x){ x.setAttribute('aria-expanded', String(!search.hidden)); });
        if (!search.hidden) search.querySelector('input[type=search]').focus();
      });
    });

    // 购物车图标：页面上有购物车抽屉时打开悬浮抽屉，否则（如 /cart 页）照常跳转
    hdr.querySelectorAll('[data-fn-cart-link]').forEach(function(a){
      a.addEventListener('click', function(e){
        if (e.metaKey || e.ctrlKey || e.shiftKey) return;
        var cd = document.querySelector('theme-drawer#cart-drawer');
        if (!cd || typeof cd.open !== 'function') return;
        e.preventDefault(); closeAll(); cd.open();
      });
    });

    // 抽屉
    var drawer = hdr.querySelector('.fn-drawer'), scrim = hdr.querySelector('.fn-drawer__scrim'), opener = hdr.querySelector('[data-fn-drawer-open]');
    function openDrawer(){ drawer.hidden = false; scrim.hidden = false; document.documentElement.style.overflow = 'hidden'; opener.setAttribute('aria-expanded','true'); drawer.querySelector('[data-fn-drawer-close]').focus(); }
    function closeDrawer(){ if (drawer.hidden) return; drawer.hidden = true; scrim.hidden = true; document.documentElement.style.overflow = ''; opener.setAttribute('aria-expanded','false'); opener.focus(); }
    opener.addEventListener('click', openDrawer);
    hdr.querySelectorAll('[data-fn-drawer-close]').forEach(function(c){ c.addEventListener('click', closeDrawer); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-hero-slides"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fh-hero]').forEach(function(s){
    if (s.dataset.fhReady) return; s.dataset.fhReady='1';
    var sl=s.querySelector('[data-fh-slides]'), dots=[].slice.call(s.querySelectorAll('.fh-dots button')), n=dots.length, cur=0, timer, rb;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches, every=(+s.dataset.autoplay||0)*1000;
    function go(i){ if(!n) return; cur=(i+n)%n; sl.scrollTo({left:sl.clientWidth*cur,behavior:reduce?'auto':'smooth'}); }
    sl.addEventListener('scroll',function(){
      var i=Math.round(sl.scrollLeft/sl.clientWidth); cur=i;
      dots.forEach(function(d,k){ d.setAttribute('aria-current',k===i?'true':'false'); });
      clearTimeout(rb); rb=setTimeout(function(){ document.dispatchEvent(new CustomEvent('fh:relayout')); },140);
    },{passive:true});
    dots.forEach(function(d,k){ d.addEventListener('click',function(){ go(k); restart(); }); });
    var pv=s.querySelector('[data-prev]'), nx=s.querySelector('[data-next]');
    if(pv) pv.addEventListener('click',function(){ go(cur-1); restart(); });
    if(nx) nx.addEventListener('click',function(){ go(cur+1); restart(); });
    function restart(){ clearInterval(timer); if(!reduce && every && n>1) timer=setInterval(function(){ go(cur+1); },every); }
    sl.addEventListener('pointerenter',function(){ clearInterval(timer); }); sl.addEventListener('pointerleave',restart); restart();
    /* 宝丽来：碰到时被「拨」一下 */
    s.querySelectorAll('[data-fh-polaroid]').forEach(function(pl){
      pl.addEventListener('pointerenter',function(){ if(!pl.classList.contains('nudge')) pl.classList.add('nudge'); });
      pl.addEventListener('animationend',function(e){ if(e.animationName==='fhNudge') pl.classList.remove('nudge'); });
    });
    /* 倒计时 */
    s.querySelectorAll('.fh-countdown').forEach(function(c){
      var end=new Date(c.dataset.end+'T23:59:59'); var ms=end-new Date(); if(isNaN(ms)||ms<=0) return;
      var d=Math.floor(ms/864e5), h=Math.floor(ms%864e5/36e5); c.textContent='Encore '+d+' j · '+h+' h'; c.hidden=false;
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-hero]').forEach(function(h){
    if (h.dataset.fnReady) return; h.dataset.fnReady = '1';
    var slides = h.querySelectorAll('.fn-hero__slide'), dots = h.querySelectorAll('[data-go]'), cards = h.querySelectorAll('[data-card]');
    if (slides.length < 2) return;
    function go(i){
      slides.forEach(function(s,k){ s.hidden = k !== i; });
      cards.forEach(function(c){ c.hidden = +c.dataset.card !== i; });
      dots.forEach(function(d,k){ d.setAttribute('aria-selected', String(k === i)); });
    }
    dots.forEach(function(d){ d.addEventListener('click', function(){ go(+d.dataset.go); }); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-main-product"]) return;
  try {
    
(function(){
  var fmt = function(cents){ return (cents/100).toFixed(2).replace('.', ',') + ' €'; };
  document.querySelectorAll('[data-fn-pdp]').forEach(function(root){
    if (root.dataset.fnReady) return; root.dataset.fnReady = '1';
    var product = JSON.parse(root.querySelector('[data-fn-product-json]').textContent);
    var form = root.querySelector('[data-fn-form]');
    var idInput = root.querySelector('[data-fn-variant-id]');
    var requireSize = root.dataset.requireSize === 'true';
    var sizeSet = root.querySelector('[data-fn-size]');
    var sticky = root.querySelector('[data-fn-sticky]');

    /* ---------- 图库 ---------- */
    var track = root.querySelector('[data-fn-gal-track]');
    var slides = track ? track.children : [];
    var thumbs = root.querySelectorAll('.fn-gal__thumb');
    var dots = root.querySelectorAll('.fn-gal__dots i');
    var nEl = root.querySelector('[data-fn-gal-n]');
    var idx = 0;
    function setActive(i){
      idx = i;
      thumbs.forEach(function(t,k){ t.setAttribute('aria-selected', String(k === i)); });
      /* 当前缩略图滚进缩略图列可视范围（只滚动列本身，不动页面） */
      var th = thumbs[i], box = th && th.parentElement;
      if (box && box.scrollHeight > box.clientHeight) {
        if (th.offsetTop < box.scrollTop) box.scrollTo({ top: th.offsetTop - 4, behavior: 'smooth' });
        else if (th.offsetTop + th.offsetHeight > box.scrollTop + box.clientHeight) box.scrollTo({ top: th.offsetTop + th.offsetHeight - box.clientHeight + 4, behavior: 'smooth' });
      }
      dots.forEach(function(d,k){ d.classList.toggle('on', k === i); });
      if (nEl) nEl.textContent = i + 1;
    }
    /* 按钮/缩略图触发的平滑滚动期间锁定目标页，避免滚动中途的位置把 idx 改回去（连点箭头会少跳） */
    var target = null, unlock = 0;
    function go(i){
      if (!slides.length) return;
      i = (i + slides.length) % slides.length;
      target = i; clearTimeout(unlock); unlock = setTimeout(function(){ target = null; }, 1000);
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' }); setActive(i);
    }
    thumbs.forEach(function(t){ t.addEventListener('click', function(){ go(+t.dataset.go); }); });
    var prev = root.querySelector('[data-fn-gal-prev]'), next = root.querySelector('[data-fn-gal-next]');
    if (prev) prev.addEventListener('click', function(){ go(idx - 1); });
    if (next) next.addEventListener('click', function(){ go(idx + 1); });
    if (track) track.addEventListener('scroll', function(){
      if (target !== null) {
        if (Math.abs(track.scrollLeft - slides[target].offsetLeft) < 2) { target = null; clearTimeout(unlock); }
        return;
      }
      var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) setActive(i);
    }, { passive: true });
    /* 用户手动滑动（触摸/触控板）时立即解锁，交回滚动位置决定当前页 */
    if (track) ['touchstart', 'wheel'].forEach(function(ev){ track.addEventListener(ev, function(){ target = null; clearTimeout(unlock); }, { passive: true }); });
    function goToMedia(id){ for (var k = 0; k < slides.length; k++) { if (slides[k].dataset.mediaId == id) { go(k); return; } } }

    var zoom = root.querySelector('[data-fn-zoom]');
    var zoomBtn = root.querySelector('[data-fn-gal-zoom]');
    if (zoomBtn && zoom) {
      zoomBtn.addEventListener('click', function(){
        var img = slides[idx] && slides[idx].querySelector('img'); if (!img) return;
        var big = new Image(); big.src = (img.currentSrc || img.src).replace(/width=\d+/, 'width=2400'); big.alt = img.alt;
        var body = zoom.querySelector('[data-fn-zoom-body]'); body.innerHTML = ''; body.appendChild(big); zoom.showModal();
        /* 打开时滚到图片中心，左右两侧都能拖到 */
        function center(){ body.scrollLeft = (body.scrollWidth - body.clientWidth) / 2; body.scrollTop = (body.scrollHeight - body.clientHeight) / 2; }
        center(); big.addEventListener('load', center, { once: true });
      });
      zoom.addEventListener('click', function(){ zoom.close(); });
    }

    /* ---------- 变体 ---------- */
    function selected(){
      return Array.prototype.map.call(root.querySelectorAll('[data-fn-option]'), function(fs){
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function update(){
      var opts = selected();
      root.querySelectorAll('[data-fn-option]').forEach(function(fs, k){
        var lab = fs.querySelector('[data-fn-opt-label]'); if (lab) lab.textContent = opts[k] ? ' — ' + opts[k] : '';
      });
      if (opts.indexOf(null) !== -1) return;
      var v = product.variants.find(function(x){ return x.options.every(function(o,k){ return o === opts[k]; }); });
      if (!v) return;
      idInput.value = v.id;
      root.querySelectorAll('[data-fn-price]').forEach(function(p){ p.textContent = fmt(v.price); });
      var cmp = root.querySelector('[data-fn-compare]'); if (cmp) { cmp.hidden = !(v.compare_at_price > v.price); cmp.textContent = fmt(v.compare_at_price || 0); }
      root.querySelectorAll('[data-fn-add]').forEach(function(b){ b.disabled = !v.available; });
      updateAddLabel(v);
      var sv = root.querySelector('[data-fn-sticky-var]'); if (sv) sv.textContent = v.title;
      if (v.featured_media) goToMedia(v.featured_media.id);
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
      root.dispatchEvent(new CustomEvent('fn:variant-change', { bubbles: true, detail: { variant: v } }));
    }
    var addLabel = root.querySelector('[data-fn-add-label]');
    var baseLabel = addLabel ? addLabel.textContent.split(' — ')[0] : '';
    var showPrice = addLabel && addLabel.textContent.indexOf(' — ') !== -1;
    var qtyInput = form.querySelector('input[name="quantity"]');
    function currentVariant(){ return product.variants.find(function(x){ return String(x.id) === String(idInput.value); }) || product.variants[0]; }
    function updateAddLabel(v){
      if (!addLabel) return;
      if (!v.available) { addLabel.textContent = 'Épuisé'; return; }
      var q = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
      addLabel.textContent = showPrice ? baseLabel + ' — ' + fmt((v.price + (psDelta || 0)) * q) : baseLabel;
      var sp = root.querySelector('.fn-sticky__price'); if (sp) sp.textContent = fmt(v.price + (psDelta || 0));
    }
    /* PatchStitch 定制加价（如图标 +2 €）：App 以附加商品行加进购物车，这里把它算进按钮总价 */
    var psRoot = document.querySelector('[data-patchstitch-root][data-price-delta-cents]');
    var psDelta = psRoot ? (+psRoot.getAttribute('data-price-delta-cents') || 0) : 0;
    document.addEventListener('patchstitch:price-change', function(e){
      psDelta = (e.detail && +e.detail.deltaCents) || 0;
      if (addLabel) updateAddLabel(currentVariant());
    });
    if (psDelta && addLabel) updateAddLabel(currentVariant());
    root.querySelectorAll('[data-fn-option] input').forEach(function(i){
      i.addEventListener('change', function(){
        var fs = i.closest('[data-fn-option]'); fs.classList.remove('is-error');
        var err = fs.querySelector('[data-fn-size-err]'); if (err) err.hidden = true;
        update();
      });
    });
    root.querySelectorAll('[data-fn-qty]').forEach(function(b){
      b.addEventListener('click', function(){ qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + (+b.dataset.fnQty)); updateAddLabel(currentVariant()); });
    });
    if (qtyInput) qtyInput.addEventListener('input', function(){ updateAddLabel(currentVariant()); });

    /* ---------- 必须选择尺码 ---------- */
    form.addEventListener('submit', function(e){
      if (requireSize && sizeSet && !sizeSet.querySelector('input:checked')) {
        e.preventDefault(); e.stopImmediatePropagation();
        sizeSet.classList.add('is-error');
        var err = sizeSet.querySelector('[data-fn-size-err]'); if (err) err.hidden = false;
        sizeSet.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var guideBtn = sizeSet.querySelector('[data-fn-guide-open]');
        if (guideBtn && window.matchMedia('(max-width: 899px)').matches) guideBtn.click();
      }
    }, true);

    /* ---------- 加购：AJAX 提交，成功后打开 Horizon 购物车抽屉 ----------
       原生 POST /cart/add 会整页跳转；在主题编辑器（iframe）里该响应带 frame-ancestors 'none'，预览会变成空白且无法操作。
       FormData 带上整张表单，定制插件写入的 properties[] 照样提交。 */
    var addErr = root.querySelector('[data-fn-add-err]');
    var cartUrl = (window.Theme && Theme.routes && Theme.routes.cart_url) || '/cart';
    var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
    form.addEventListener('submit', function(e){
      if (e.defaultPrevented) return;
      var drawer = document.querySelector('theme-drawer#cart-drawer');
      if (!drawer || !window.fetch || !window.FormData) return; /* 购物车类型为「页面」时保持原生跳转 */
      e.preventDefault();
      if (form.dataset.fnSubmitting === 'true') return;
      form.dataset.fnSubmitting = 'true';
      var btns = root.querySelectorAll('[data-fn-add]');
      btns.forEach(function(b){ b.disabled = true; b.setAttribute('aria-busy', 'true'); });
      if (addErr) addErr.hidden = true;

      var fd = new FormData(form);
      var items = drawer.querySelector('cart-items-component');
      var sectionId = items && items.dataset.sectionId;
      if (sectionId) fd.append('sections', sectionId);

      /* 通知 Horizon：购物车抽屉和计数会在 promise 完成后刷新。模块加载慢或失败都不阻塞开抽屉 */
      var settle = null;
      var events = import('@shopify/events').then(function(m){
        var d = m.CartLinesUpdateEvent.createPromise();
        settle = d;
        form.dispatchEvent(new m.CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(fd.get('id')), quantity: Number(fd.get('quantity')) || 1 }], promise: d.promise }));
        return m;
      }).catch(function(){ return null; });

      var added = false;
      fetch(addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function(r){ return r.json().then(function(res){ return { ok: r.ok, res: res }; }); })
        .then(function(o){
          var res = o.res;
          if (!o.ok || res.status) { var err = new Error(res.description || res.message || 'Erreur'); err.shown = true; throw err; }
          added = true;
          /* 加购成功立即打开抽屉，内容随后由 Horizon 刷新 */
          if (window.Shopify && Shopify.actions && Shopify.actions.openCart) Shopify.actions.openCart();
          else if (drawer.open) drawer.open();
          return fetch(cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function(r){ return r.json(); }).then(function(cart){
            document.querySelectorAll('[data-fn-cart-count]').forEach(function(c){ c.textContent = cart.item_count; c.hidden = !cart.item_count; });
            document.dispatchEvent(new CustomEvent('fn:cart-count', { detail: { count: cart.item_count } }));
            document.querySelectorAll('[data-fn-cart-link]').forEach(function(a){ a.setAttribute('aria-label', 'Panier, ' + cart.item_count + ' article(s)'); });
            return events.then(function(m){
              if (settle && m) settle.resolve({ cart: m.CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: res.sections, source: 'fn-main-product', didError: false } });
            });
          });
        })
        .catch(function(err){
          events.then(function(){ if (settle) settle.reject(err); });
          if (added) return; /* 已加入购物车，只是刷新失败：不提示错误 */
          if (!err.shown) {
            if (addErr) {
              addErr.textContent = root.dataset.fnCartUncertain;
              var checkCart = document.createElement('a');
              checkCart.href = cartUrl;
              checkCart.textContent = root.dataset.fnCheckCart;
              addErr.appendChild(document.createTextNode(' '));
              addErr.appendChild(checkCart);
              addErr.hidden = false;
            }
            return;
          }
          if (addErr) { addErr.textContent = err.message; addErr.hidden = false; }
        })
        .finally(function(){
          delete form.dataset.fnSubmitting;
          var v = currentVariant();
          btns.forEach(function(b){ b.disabled = !v.available; b.removeAttribute('aria-busy'); });
        });
    });

    /* ---------- 尺码表 ---------- */
    var guide = root.querySelector('[data-fn-guide]');
    if (guide) {
      root.querySelectorAll('[data-fn-guide-open]').forEach(function(b){ b.addEventListener('click', function(){ guide.showModal(); }); });
      guide.querySelector('[data-fn-guide-close]').addEventListener('click', function(){ guide.close(); });
      guide.addEventListener('click', function(e){ if (e.target === guide) guide.close(); });
    }

    /* ---------- 配送预估 ---------- */
    var ship = root.querySelector('[data-fn-ship]');
    if (ship) {
      var addBiz = function(n){ var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'long' }); };
      ship.querySelector('[data-fn-d1]').textContent = addBiz(+ship.dataset.min);
      ship.querySelector('[data-fn-d2]').textContent = addBiz(+ship.dataset.max);
      var short = function(n){ var d = new Date(); while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) n--; } return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'short' }); };
      ship.querySelectorAll('.fn-tl li[data-days]').forEach(function(li){
        var t = short(+li.dataset.days); if (li.dataset.daysTo) t += ' – ' + short(+li.dataset.daysTo);
        li.querySelector('[data-fn-tl]').textContent = t;
      });
    }

    /* ---------- 活动提示 ----------
       档位全部来自手动设置，不发任何购物车 / API 请求。
       进度：按「购物车已有件数 + 当前数量」点亮档位、推进度条、提示下一档。 */
    var promo = root.querySelector('[data-fn-promo]');
    if (promo) {
      var tiersBox = promo.querySelector('[data-fn-promo-tiers]');
      var stepsEl = promo.querySelector('.fn-promo__steps');
      var trackEl = promo.querySelector('.fn-promo__track');
      var fill = promo.querySelector('[data-fn-promo-fill]');
      var msg = promo.querySelector('[data-fn-promo-msg]');
      var inCart = +promo.dataset.cart || 0;
      /* 购物车已有商品时，只按购物车件数显示；用户主动改了数量框才把数量算进去预览 */
      var qtyTouched = false;
      var tiers = [];
      var esc = function(t){ var d = document.createElement('span'); d.textContent = t; return d.innerHTML; };
      var tpl = function(t, n, offer, next){
        return esc(t).replace(/\[n\]/g, n).replace(/\[pi[eè]ces?\]/g, n > 1 ? 'pièces' : 'pièce')
          .replace(/\[offre\]/g, '<b>' + esc(offer || '') + '</b>').replace(/\[suivante\]/g, '<b>' + esc(next || '') + '</b>');
      };
      var useTiers = function(list){
        tiers = list.sort(function(a, b){ return a.min - b.min; });
        trackEl.style.setProperty('--n', tiers.length);
        tiers.forEach(function(t, i){ t.el.style.setProperty('--i', i + 1); stepsEl.appendChild(t.el); });
        tiersBox.hidden = !tiers.length;
        renderPromo();
      };
      var renderPromo = function(){
        if (!tiers.length) return;
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var total = inCart + (inCart && !qtyTouched ? 0 : qty);
        var on = null, next = null, k = 0;
        tiers.forEach(function(t, i){ var hit = t.min <= total; t.el.classList.toggle('is-on', hit); if (hit) { on = t; k = i + 1; } else if (!next) next = t; });
        var prevMin = on ? on.min : 0;
        var pos = next ? (k + (total - prevMin) / (next.min - prevMin)) / tiers.length : 1;
        fill.style.width = Math.max(0, Math.min(1, pos)) * 100 + '%';
        if (!next) msg.innerHTML = tpl(promo.dataset.msgTop, 0, on.label);
        else if (!on) msg.innerHTML = tpl(promo.dataset.msgNext, next.min - total, next.label);
        else msg.innerHTML = tpl(promo.dataset.msgOn, next.min - total, on.label, next.label);
      };
      /* 手动档位 */
      if (stepsEl.children.length) {
        useTiers(Array.prototype.slice.call(stepsEl.children).map(function(li){ return { el: li, min: +li.dataset.min, label: li.querySelector('b').textContent.trim() }; }));
      }

      var onQty = function(){ qtyTouched = true; renderPromo(); };
      if (qtyInput) qtyInput.addEventListener('input', onQty);
      root.querySelectorAll('[data-fn-qty]').forEach(function(b){ b.addEventListener('click', onQty); });
      document.addEventListener('fn:cart-count', function(e){
        inCart = e.detail.count; qtyTouched = false; if (qtyInput) qtyInput.value = 1; renderPromo();
      });
    }

    /* ---------- 移动端粘性栏两段式：到达购买区之前 =「Dès xx € · Créer ma broderie」（锚点），之后 = 价格 + 加购 ---------- */
    if (sticky) {
      var mobile = window.matchMedia('(max-width: 899px)');
      var updatePre = function(){ sticky.classList.toggle('is-pre', mobile.matches && root.getBoundingClientRect().top > window.innerHeight * .6); };
      /* 桌面端 Horizon 由 .page-wrapper 滚动而非 window，用捕获阶段监听才能收到 */
      document.addEventListener('scroll', updatePre, { passive: true, capture: true }); updatePre();
      var toBuy = sticky.querySelector('[data-fn-to-buy]');
      /* 粘性栏只在手机端出现：有定制面板就直接跳到面板，不再停在图库顶部 */
      if (toBuy) toBuy.addEventListener('click', function(e){ e.preventDefault(); var t = root.querySelector('.fn-config') || root; t.style.scrollMarginTop = (((document.querySelector('.fn-hdr') || {}).offsetHeight || 0) + 8) + 'px'; t.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    }

    /* ---------- 桌面粘性栏：主按钮离开视口后出现 ---------- */
    var mainAdd = root.querySelector('[data-fn-atc-wrap]');
    if (sticky && mainAdd && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){
        var e = entries[0];
        sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainAdd);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-pdp-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-ph]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var slides = s.querySelectorAll('.fn-ph__vid'), chaps = s.querySelectorAll('.fn-ph__chap');
    var playBtn = s.querySelector('[data-fn-ph-play]'), soundBtn = s.querySelector('[data-fn-ph-sound]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cur = 0, playing = !reduce, muted = true, IMG_MS = 4000, imgTimer, raf;
    function vid(i){ return slides[i] && slides[i].querySelector('video'); }
    function setProgress(){
      var v = vid(cur);
      chaps.forEach(function(c, k){ var p = k < cur ? 1 : k > cur ? 0 : (v && v.duration ? v.currentTime / v.duration : (c._p || 0)); c.style.setProperty('--p', p); });
      raf = requestAnimationFrame(setProgress);
    }
    function go(i){
      var old = vid(cur); if (old) old.pause();
      cur = (i + slides.length) % slides.length;
      slides.forEach(function(sl, k){ sl.hidden = k !== cur; });
      chaps.forEach(function(c, k){ c.setAttribute('aria-selected', String(k === cur)); c._p = 0; });
      var v = vid(cur);
      clearInterval(imgTimer);
      if (v) { v.muted = muted; v.currentTime = 0; if (playing) v.play().catch(function(){}); }
      else if (playing && slides.length > 1) {
        var t0 = Date.now(), c = chaps[cur];
        imgTimer = setInterval(function(){ var p = (Date.now() - t0) / IMG_MS; if (c) c._p = Math.min(1, p); if (p >= 1) { clearInterval(imgTimer); go(cur + 1); } }, 100);
      }
    }
    slides.forEach(function(sl, k){
      var v = sl.querySelector('video'); if (!v) return;
      v.loop = slides.length === 1;
      v.addEventListener('ended', function(){ if (k === cur && playing) go(cur + 1); });
    });
    chaps.forEach(function(c){ c.addEventListener('click', function(){ go(+c.dataset.go); }); });
    playBtn.addEventListener('click', function(){
      playing = !playing; var v = vid(cur);
      if (v) playing ? v.play() : v.pause(); else if (playing) go(cur);
      if (!playing) clearInterval(imgTimer);
      playBtn.setAttribute('aria-label', playing ? 'Mettre en pause' : 'Lire');
      playBtn.innerHTML = playing ? '<svg class="fn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="14" y="4" width="4" height="16" rx="1"/><rect x="6" y="4" width="4" height="16" rx="1"/></svg>' : '<svg class="fn-icon" width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><polygon points="6 3 20 12 6 21 6 3"/></svg>';
    });
    soundBtn.addEventListener('click', function(){
      muted = !muted; var v = vid(cur); if (v) v.muted = muted;
      soundBtn.setAttribute('aria-pressed', String(!muted));
      soundBtn.setAttribute('aria-label', muted ? 'Activer le son' : 'Couper le son');
      soundBtn.innerHTML = muted ? '<svg class="fn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/><line x1="22" x2="16" y1="9" y2="15"/><line x1="16" x2="22" y1="9" y2="15"/></svg>' : '<svg class="fn-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M11 4.702a.705.705 0 0 0-1.203-.498L6.413 7.587A1.4 1.4 0 0 1 5.416 8H3a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h2.416a1.4 1.4 0 0 1 .997.413l3.383 3.384A.705.705 0 0 0 11 19.298z"/><path d="M16 9a5 5 0 0 1 0 6"/></svg>';
    });
    // 视频不在视口时暂停，节省流量
    if ('IntersectionObserver' in window) new IntersectionObserver(function(e){ var v = vid(cur); if (!v) return; if (e[0].isIntersecting && playing) v.play().catch(function(){}); else v.pause(); }).observe(s);
    // 锚点平滑滚动（避开粘性页头）
    s.querySelectorAll('[data-fn-anchor]').forEach(function(a){
      a.addEventListener('click', function(e){
        var t = document.querySelector(a.getAttribute('href')); if (!t) return;
        /* 手机端图库在定制面板上方约一屏多：直接跳到「Personnalisez votre pièce」 */
        var cfg = window.matchMedia('(max-width: 899px)').matches && t.querySelector('.fn-config'); if (cfg) t = cfg;
        e.preventDefault(); t.style.scrollMarginTop = (((document.querySelector('.fn-hdr') || {}).offsetHeight || 0) + 8) + 'px';
        /* scrollIntoView 对 window 和 Horizon 桌面端的 .page-wrapper 滚动容器都有效 */
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    go(0); setProgress();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-photo-embroidery"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-pe]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var rail = s.querySelector('[data-fn-pe-rail]'), dots = s.querySelectorAll('.fn-pe__prog i');
    rail.addEventListener('scroll', function(){
      var first = rail.children[0]; if (!first) return;
      var i = Math.round(rail.scrollLeft / (first.offsetWidth + 12));
      dots.forEach(function(d,k){ d.classList.toggle('on', k === i); });
    }, { passive: true });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-promo-slider"] && !Shopify.designMode) return;
  try {
    
(function(){
  function pad(n){ return (n < 10 ? '0' : '') + n; }
  function init(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var track = s.querySelector('[data-fn-promo-track]');
    var cur = s.querySelector('[data-fn-promo-cur]');
    var delay = parseInt(s.dataset.autoplay, 10) * 1000 || 0;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, t0 = 0, raf = 0, paused = false, visible = true;

    // 倒计时：过期的活动整张隐藏
    s.querySelectorAll('[data-end]').forEach(function(sl){
      var end = new Date(sl.dataset.end + 'T23:59:59');
      var cd = sl.querySelector('[data-fn-promo-cd]'), txt = sl.querySelector('[data-fn-promo-cd-txt]');
      if (isNaN(end)) return;
      function tick(){
        var ms = end - new Date();
        if (ms <= 0) { if (!window.Shopify || !Shopify.designMode) sl.hidden = true; if (cd) cd.hidden = true; return false; }
        var d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60;
        if (txt) txt.textContent = d > 0 ? 'Encore ' + d + ' j · ' + pad(h) + ' h' : 'Plus que ' + pad(h) + ' h ' + pad(m) + ' min';
        if (cd) cd.hidden = false; return true;
      }
      if (tick()) setInterval(tick, 30000);
    });

    function slides(){ return Array.prototype.filter.call(s.querySelectorAll('[data-fn-promo-slide]'), function(x){ return !x.hidden; }); }
    function dots(){ return s.querySelectorAll('[data-fn-promo-dot]'); }
    function syncDots(){
      var list = slides();
      dots().forEach(function(d, i){
        d.hidden = i >= list.length;
        if (i === idx) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
        d.style.removeProperty('--p');
      });
      if (cur) cur.textContent = pad(idx + 1);
      t0 = performance.now(); s.dataset.elapsed = 0;
    }
    function go(i){
      var list = slides(); if (!list.length) return;
      idx = (i + list.length) % list.length;
      track.scrollTo({ left: list[idx].offsetLeft - list[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      syncDots();
    }
    // 手动滑动后，同步当前项
    var st;
    track.addEventListener('scroll', function(){
      clearTimeout(st);
      st = setTimeout(function(){
        var list = slides(), best = 0, min = Infinity;
        list.forEach(function(x, i){ var dd = Math.abs(x.offsetLeft - list[0].offsetLeft - track.scrollLeft); if (dd < min) { min = dd; best = i; } });
        if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 4) best = list.length - 1;
        if (best !== idx) { idx = best; syncDots(); }
      }, 120);
    }, { passive: true });

    var prev = s.querySelector('[data-fn-promo-prev]'), next = s.querySelector('[data-fn-promo-next]');
    if (prev) prev.addEventListener('click', function(){ go(idx - 1); });
    if (next) next.addEventListener('click', function(){ go(idx + 1); });
    dots().forEach(function(d){ d.addEventListener('click', function(){ go(parseInt(d.dataset.fnPromoDot, 10)); }); });
    track.addEventListener('keydown', function(e){
      if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
    });

    // 自动轮播：分页缝线同时显示进度
    function loop(now){
      raf = requestAnimationFrame(loop);
      if (paused || !visible) { t0 = now - (parseFloat(s.dataset.elapsed) || 0); return; }
      var el = now - t0; s.dataset.elapsed = el;
      var d = dots()[idx]; if (d) d.style.setProperty('--p', Math.min(el / delay, 1));
      if (el >= delay) go(idx + 1);
    }
    if (delay && !reduce && slides().length > 1) {
      ['mouseenter', 'focusin', 'touchstart'].forEach(function(ev){ s.addEventListener(ev, function(){ paused = true; }, { passive: true }); });
      ['mouseleave', 'focusout'].forEach(function(ev){ s.addEventListener(ev, function(){ paused = false; }); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function(en){ visible = en[0].isIntersecting && !document.hidden; }).observe(s);
      t0 = performance.now(); raf = requestAnimationFrame(loop);
    }
    syncDots();

    // 主题编辑器：选中某个活动块时滚到它
    s.addEventListener('shopify:block:select', function(e){
      paused = true;
      var i = slides().indexOf(e.target); if (i > -1) go(i);
    });
    s.addEventListener('shopify:block:deselect', function(){ paused = false; });
  }
  function boot(){ document.querySelectorAll('[data-fn-promo]').forEach(init); }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-proof-bar"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-proof]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var qs = s.querySelectorAll('.fn-proof__q'), i = 0, paused = false;
    if (qs.length < 2) return;
    function next(){ qs[i].hidden = true; i = (i + 1) % qs.length; qs[i].hidden = false; }
    s.querySelector('[data-fn-proof-next]').addEventListener('click', next);
    s.addEventListener('mouseenter', function(){ paused = true; });
    s.addEventListener('mouseleave', function(){ paused = false; });
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) setInterval(function(){ if (!paused) next(); }, 5000);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-related"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-rel]').forEach(function(s){
    if (s.dataset.fnReady || s.hasAttribute('data-manual')) return; s.dataset.fnReady = '1';
    var grid = s.querySelector('[data-fn-rel-grid]');
    if (grid.children.length) return;
    function load(url){
      return fetch(url).then(function(r){ return r.text(); }).then(function(html){
        var d = document.createElement('div'); d.innerHTML = html;
        var g = d.querySelector('[data-fn-rel-grid]');
        return g && g.children.length ? g.innerHTML : '';
      });
    }
    var io = new IntersectionObserver(function(e){
      if (!e[0].isIntersecting) return; io.disconnect();
      load(s.dataset.url).then(function(html){
        if (html) { grid.innerHTML = html; return; }
        return load(s.dataset.url.replace('intent=complementary', 'intent=related')).then(function(h2){ if (h2) grid.innerHTML = h2; else s.hidden = true; });
      });
    }, { rootMargin: '0px 0px 400px 0px' });
    io.observe(s);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-rev]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var chips = s.querySelectorAll('[data-filter]');
    chips.forEach(function(c){
      c.addEventListener('click', function(){
        chips.forEach(function(x){ x.setAttribute('aria-pressed', String(x === c)); });
        s.querySelectorAll('.fn-rev__card').forEach(function(card){
          var f = c.dataset.filter;
          card.hidden = f === 'photo' ? card.dataset.photo !== '1' : f === 'gift' ? card.dataset.gift !== '1' : false;
        });
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-stickers"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fh-why]').forEach(function(why){
    if (why.dataset.fhReady) return; why.dataset.fhReady='1';
    var stks=[].slice.call(why.querySelectorAll('.fh-stk')), lis=[].slice.call(why.querySelectorAll('.fh-points li'));
    function act(i){ why.classList.toggle('has-act',i!==null); stks.forEach(function(x){x.classList.toggle('on',x.dataset.i===i)}); lis.forEach(function(x){x.classList.toggle('on',x.dataset.i===i)}); }
    stks.concat(lis).forEach(function(el){
      el.addEventListener('pointerenter',function(){act(el.dataset.i)}); el.addEventListener('focus',function(){act(el.dataset.i)});
      el.addEventListener('pointerleave',function(){act(null)}); el.addEventListener('blur',function(){act(null)});
      el.addEventListener('click',function(){act(el.dataset.i)});
    });
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(!e.isIntersecting) return; io.disconnect();
      stks.forEach(function(x,k){ setTimeout(function(){ x.classList.add('pop'); },k*260); }); }); },{threshold:.45});
    io.observe(why.querySelector('.fh-why__vis'));
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-thread"] && !Shopify.designMode) return;
  try {
    
(function(){
  var svg=document.querySelector('[data-fh-thread]'); if(!svg||svg.dataset.fhReady) return; svg.dataset.fhReady='1';
  var main=document.getElementById('MainContent')||svg.parentElement;
  var ghost=svg.querySelector('.fh-thread__ghost'), live=svg.querySelector('.fh-thread__live'), len=0, ended=false;
  /* 页面可能在内部容器（如 .page-wrapper）里滚动，而不是窗口本身：找出真正在滚动的那个 */
  function scroller(){
    var se=document.scrollingElement||document.documentElement;
    if(se.scrollHeight>window.innerHeight+2 && getComputedStyle(document.documentElement).overflowY!=='hidden') return se;
    for(var el=main.parentElement; el && el!==document.body; el=el.parentElement){
      var oy=getComputedStyle(el).overflowY; if((oy==='auto'||oy==='scroll') && el.scrollHeight>el.clientHeight+2) return el;
    }
    return se;
  }

  function pts(){
    var mb=main.getBoundingClientRect(), list=[], vw=window.innerWidth;
    var starts=[].slice.call(main.querySelectorAll('[data-knot="start"]'));
    var st=starts.filter(function(el){ var r=el.getBoundingClientRect(); return r.width && r.left>=-2 && r.right<=vw+2; })[0]||starts[0];
    if(st){ var sp=(st.querySelector('.fh-spool')||st).getBoundingClientRect(); list.push({x:sp.left-8-mb.left, y:sp.top+sp.height*0.62-mb.top, start:true, festive:!!st.closest('.fh-festive')}); }
    main.querySelectorAll('[data-knot]:not([data-knot="start"])').forEach(function(el){
      var r=el.getBoundingClientRect(); if(!r.width) return;
      var end=el.dataset.knot==='end';
      if(!end && r.left-mb.left > mb.width*.4) return;
      list.push({x:(end? r.left+r.width/2 : r.left-6)-mb.left, y:(end? r.top+6 : r.top+r.height/2)-mb.top});
    });
    return list;
  }
  function build(){
    var p=pts(); if(p.length<2) return;
    var mb=main.getBoundingClientRect();
    var g=Math.max(10, Math.min(28, (window.innerWidth-Math.min(window.innerWidth,1200))/2+10));
    svg.setAttribute('width',mb.width); svg.setAttribute('height',mb.height);
    var d='M'+p[0].x+' '+p[0].y;
    for(var i=1;i<p.length;i++){
      var a=p[i-1], b=p[i], last=i===p.length-1, gx=g, y1=a.y+50, y2=b.y-50;
      if(a.start){ var dx=a.x-gx, R=Math.max(120, dx*0.75), ey=Math.min(a.y+R, y2-20); d+=' C'+(a.x-dx*0.55)+' '+(a.y+4)+' '+gx+' '+(a.y+(ey-a.y)*0.3)+' '+gx+' '+ey; }
      else { d+=' C'+(a.x-40)+' '+a.y+' '+gx+' '+(a.y+10)+' '+gx+' '+y1; }
      if(last){ d+=' L'+gx+' '+(y2-40)+' C'+gx+' '+(b.y-10)+' '+(b.x-60)+' '+(b.y-30)+' '+b.x+' '+b.y; }
      else { d+=' L'+gx+' '+y2+' C'+gx+' '+(b.y-10)+' '+(b.x-30)+' '+b.y+' '+b.x+' '+b.y; }
    }
    ghost.setAttribute('d',d); live.setAttribute('d',d);
    /* 圣诞装饰：当前首屏轮播勾选了「圣诞装饰」时，在线的第一段上挂三颗圣诞球 */
    var bb=svg.querySelector('.fh-thread__baubles'); bb.innerHTML='';
    if(p[0].festive){
      var seg=document.createElementNS('http://www.w3.org/2000/svg','path'); seg.setAttribute('d',d.split(' L')[0]); bb.appendChild(seg);
      var sl=seg.getTotalLength(), fills=['#FFFBF5','#CFD9C3','#F1E2BC'], html='';
      [0.2,0.42,0.66].forEach(function(f,k){ var q=seg.getPointAtLength(sl*f); html+='<g data-at="'+(sl*f)+'"><path d="M'+q.x+' '+q.y+'v6"/><circle cx="'+q.x+'" cy="'+(q.y+11)+'" r="5" fill="'+fills[k]+'"/></g>'; });
      bb.innerHTML=html;
    }
    len=live.getTotalLength(); live.style.strokeDasharray=len; draw();
  }
  function draw(){
    if(!len) return;
    var reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var sc=scroller(), isDoc=(sc===document.scrollingElement||sc===document.documentElement);
    var vh=isDoc?window.innerHeight:sc.clientHeight, max=sc.scrollHeight-vh;
    var y=sc.scrollTop;
    function base(v){ return Math.min(1,(v+vh*.6)/(max+vh*.6)); }   /* 原来的速度：页面前面部分完全不变 */
    var t=base(y);
    /* 只在最后约半屏加快一点：结尾线结滑到屏幕约 3/4 高度时，线正好连上线结（不必滚过页脚） */
    var knot=main.querySelector('[data-knot="end"]');
    if(knot){
      var top=isDoc?0:sc.getBoundingClientRect().top;
      var sEnd=knot.getBoundingClientRect().top-top+y-vh*.75;
      if(sEnd<max){
        var sA=Math.max(0,sEnd-vh*.6);
        if(y>=sEnd) t=1; else if(y>sA) t=base(sA)+(1-base(sA))*(y-sA)/(sEnd-sA);
      }
    }
    if(reduce) t=1;
    live.style.strokeDashoffset=len*(1-t);
    svg.querySelectorAll('.fh-thread__baubles g').forEach(function(g){ g.style.opacity=(len*t>=+g.dataset.at)?1:0; });
    if(t>=0.999 && !ended){ ended=true; document.dispatchEvent(new CustomEvent('fh:thread-end')); }
  }
  /* 捕获阶段监听：无论是窗口还是内部容器在滚动，都能收到 */
  document.addEventListener('scroll',draw,{capture:true,passive:true});
  window.addEventListener('resize',build);
  document.addEventListener('fh:relayout',build);
  if(document.fonts&&document.fonts.ready) document.fonts.ready.then(build);
  window.addEventListener('load',build); build();
  if('ResizeObserver' in window) new ResizeObserver(function(){ clearTimeout(svg._t); svg._t=setTimeout(build,120); }).observe(main);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-trio"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fh-styles]').forEach(function(s){
    if (s.dataset.fhReady) return; s.dataset.fhReady='1';
    var boxes=s.querySelectorAll('.fh-ba');
    boxes.forEach(function(box){ var r=box.querySelector('.fh-ba__range'); r.addEventListener('input',function(){ box.classList.remove('hint'); box.style.setProperty('--pos',r.value+'%'); }); });
    if(!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io=new IntersectionObserver(function(es){ es.forEach(function(e){
      if(!e.isIntersecting) return; io.unobserve(e.target); var b=e.target, st=b.querySelector('.fh-ba__range').value;
      b.classList.add('hint'); setTimeout(function(){ b.style.setProperty('--pos','80%'); },200);
      setTimeout(function(){ b.style.setProperty('--pos',st+'%'); },1200); setTimeout(function(){ b.classList.remove('hint'); },2200);
    }); },{threshold:.6});
    boxes.forEach(function(b){ io.observe(b); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-ugc"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-ugc]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var dlg = s.querySelector('dialog'), body = s.querySelector('[data-fn-ugc-body]');
    s.querySelectorAll('[data-fn-ugc-open]').forEach(function(b){
      b.addEventListener('click', function(){
        var tpl = document.getElementById('FnUgc-' + b.dataset.fnUgcOpen);
        body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true)); dlg.showModal();
      });
    });
    s.querySelector('[data-fn-ugc-close]').addEventListener('click', function(){ dlg.close(); });
    dlg.addEventListener('click', function(e){ if (e.target === dlg) dlg.close(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fn-video-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-fn-vids]').forEach(function(s){
    if (s.dataset.fnReady) return; s.dataset.fnReady = '1';
    var dlg = s.querySelector('dialog'), body = s.querySelector('[data-fn-vid-body]');
    var canHover = window.matchMedia('(hover:hover)').matches;
    s.querySelectorAll('[data-fn-vid]').forEach(function(b){
      var pv = b.querySelector('video');
      if (pv && canHover) { b.addEventListener('mouseenter', function(){ pv.play(); }); b.addEventListener('mouseleave', function(){ pv.pause(); }); }
      b.addEventListener('click', function(){
        var tpl = document.getElementById('FnVid-' + b.dataset.fnVid); if (!tpl) return;
        body.innerHTML = ''; body.appendChild(tpl.content.cloneNode(true)); dlg.showModal();
      });
    });
    function close(){ body.innerHTML = ''; dlg.close(); }
    s.querySelector('[data-fn-vid-close]').addEventListener('click', close);
    dlg.addEventListener('click', function(e){ if (e.target === dlg) close(); });
    dlg.addEventListener('cancel', function(){ body.innerHTML = ''; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
